module.exports = __webpack_public_path__ + "img/moca-taipei.6902e82c.svg";